import React from "react";
import PropTypes from "prop-types";
import { noop, map, isEqual, isEmpty, capitalize } from "lodash";
import {
  Button,
  Pagination,
  Select,
  SearchSelect,
} from "../../components/base";
import BaseTable from "../../components/BaseTable/BaseTable.component";
import { formatData, normalizeAmount } from "../../utils/transformer.util";
import language from "../../languages";
import { errorAlert } from "../../utils/alert.util";
import { LIST_PENDAFTARAN_PPDB_LIST_TABLE_FIELDS } from "../../constants/Student/student.constant";

const initialContent = {
  loading: true,
  list: [],
  currentPage: 1,
  total: 1,
  totalPage: 1,
  error: false,
};

export default class StrukturUnitPusat extends BaseTable {
  constructor(props) {
    super(props);
    this.onClickAdd = this.onClickAdd.bind(this);
    this._onFormChange = this._onFormChange.bind(this);
    this.onClickEdit = this.onClickEdit.bind(this);
    this.onClickRutin = this.onClickRutin.bind(this);
    this.onClickTidakRutin = this.onClickTidakRutin.bind(this);
    this.handleGetData = this.handleGetData.bind(this);
    this.onChangePage = this.onChangePage.bind(this);
    this._onSearchContent = this._onSearchContent.bind(this);
    this._onChangeFilter = this._onChangeFilter.bind(this);
    this._getPrmPositionOption = this._getPrmPositionOption.bind(this);
    this._getPrmPositionAdmOption = this._getPrmPositionAdmOption.bind(this);
    this._getParamOptionsAcademics = this._getParamOptionsAcademics.bind(this);
    this._getPeriodsOptions = this._getPeriodsOptions.bind(this);
    this._initializeData = this._initializeData.bind(this);
    this._getSchoolUnitsManageOptions =
      this._getSchoolUnitsManageOptions.bind(this);
    this.onSubmit = this.onSubmit.bind(this);
    this.onPosting = this.onPosting.bind(this);
    this._getPrmStaffMasterIDOptions = this._getPrmStaffMasterIDOptions.bind(this);
    this.onClickSubmit = this.onClickSubmit.bind(this);

    const { user } = this.props;
    const { school_unit } = user;
    const { levels_id } = school_unit;
    this.state = {
      page: 1,
      selected: {},
      content: initialContent,
      unchecked: {},
      filters: {},
      list: [],
      form: {
        value: {
          details: [],
          units_id: school_unit.id,
          user_id: user.id,
        },
        error: {
          details: [],
        },
      },
      param: {},
      filtered: false,
    };
  }

  componentDidMount() {
    const { user } = this.props;
    const { organizations_id, user_group } = user;
    const { content, form, filters } = this.state;
    let savedForm =
      JSON.parse(window.localStorage.getItem("strukturForm")) || "";
    let savedFilters =
      JSON.parse(window.localStorage.getItem("strukturFilters")) || filters;
    if (savedForm != "" && user.id != savedForm.value.user_id) {
      savedForm = "";
      savedFilters = filters;
    }
    console.log(savedForm);
    this._initializeData(savedFilters);
    if (savedForm != "") {
      this.setState((prevState) => ({
        ...prevState,
        form: {
          ...prevState.form,
          value: {
            ...prevState.form.value,
            levels_id: savedForm.value.levels_id,
            units_id: savedFilters.units_id ? savedFilters.units_id : "",
            details: savedForm.value.details,
          },
        },
        filters: {
          ...prevState.filters,
          units_id: savedFilters.units_id ? savedFilters.units_id : "",
          // entrance_year : savedFilters.entrance_year,
        },
      }));

      // this._getParamOptionsAcademics("classrooms", {
      //   levels_id: savedForm.value.levels_id,
      //   classes_id: savedForm.value.classes_id,
      //   units_id: savedForm.value.units_id.value,
      //   organizations_id,
      // });

      if (user_group.name === "pusat") {
        this._getPeriodsOptions({ units_id: savedForm.value.units_id.value });
      }
    }
  }

 

  componentDidUpdate(prevProps, prevState) {
    const { form } = this.state;
    const { details } = form.value;
    const { form: prevForm } = prevState;
    const { details: prevDetails } = prevForm.value;
    if (details !== prevDetails) {
      this._getPrmStaffMasterIDOptions();
    }
    const { user } = this.props;
    const { workingUnit } = user;
    const { user: prevUser } = prevProps;
    const { workingUnit: prevWorkingUnit } = prevUser;
  }

  async _initializeData(savedFilters = {}) {
    const { user } = this.props;
    const { content } = this.state;
    const { school_unit, user_group } = user;
    await this._getSchoolUnitsManageOptions();
    await this._getPrmStaffMasterIDOptions();

    if (user_group.name == "pusat") {
      this.setState(
        (prevState) => ({
          filters: {
            ...prevState.filters,
            classrooms_id: savedFilters.classrooms_id,
            jenis: savedFilters.jenis,
            payments_id: savedFilters.payments_id,
            period_id: savedFilters.period_id,
          },
        }),
        () => {
          // commonActions.setLoading({ show: true });
          this._onSearchContent();
        }
      );
    }
    //  this._getPrmPositionOption({unit_code: school_unit.unit_code});
    // this._getPeriodsOptions();

    //  this._onSearchContent();
  }

  async onClickDelete(id) {
    const { handleDeleteDetailsPosition } = this.props;
    const res = await handleDeleteDetailsPosition(id);
    if (res) {
      this._onSearchContent();
    }
  }

  async _getPrmStaffMasterIDOptions(filters = {}) {
    const { getPrmStaffMasterIDOptions, user } = this.props;
    const { school_unit, user_group } = user;
    const { levels_id } = school_unit;
    const res = await getPrmStaffMasterIDOptions(filters);
    this.setState((prevState) => ({
      ...prevState,
      param: {
        ...prevState.param,
        staff: res,
      },
    }));
  }

  async _getSchoolUnitsManageOptions(filters = {}) {
    const { getSchoolUnitsManageOptions } = this.props;
    const { form } = this.state;
    const { units_id } = form.value;
    const res = await getSchoolUnitsManageOptions(filters);
    const selectedUnits = res.find((item) => item.value == units_id);

    this.setState((prevState) => ({
      ...prevState,
      form: {
        ...prevState.form,
        value: {
          ...prevState.form.value,
          levels_units: selectedUnits ? selectedUnits.attributes.levels_id : "",
        },
      },
      param: {
        ...prevState.param,
        units: res,
      },
    }));
  }

  async _getStudentSPPOptions(filters = {}) {
    const { getStudentSPPOptions } = this.props;
    const res = await getStudentSPPOptions(filters);
    this.setState((prevState) => ({
      ...prevState,
      param: {
        ...prevState.param,
        student_prm: res,
      },
    }));
  }

  _onChangeFilter(e) {
    const { user, getPeriodsOptions } = this.props;
    const { form, filters } = this.state;
    const { organizations_id, school_unit } = user;
    const { target } = e;
    const { value, name } = target;
    this.setState(
      (prevState) => ({
        ...prevState,
        filters: {
          ...prevState.filters,
          [name]: value,
        },
        // param: {
        //   ...prevState.param,
        //   student: res,
        // },
      }),
      () => {
        window.localStorage.setItem(
          "strukturFilters",
          JSON.stringify(this.state.filters)
        );
        window.localStorage.setItem(
          "strukturForm",
          JSON.stringify(this.state.form)
        );
        if (name === "units_id") {
          console.log(filters);
          this.setState((prevState) => ({
            ...prevState,
            form: {
              ...prevState.form,
              value: {
                ...prevState.form.value,
                classrooms_id: "",
                units_id: value,
              },
            },
            filters: {
              ...prevState.filters,
              // entrance_year:''
              // periods: periods_value,
            },
          }));
          this._getPeriodsOptions({ units_id: value.value });
        }
        this._onSearchContent();
      }
    );
  }

  async _onSearchContent(params = {}) {
    const { filters, form, param } = this.state;
    const {
      students_id = "",
      entrance_year,
      units_id,
      period_id,
      period,
    } = filters;
    const {
      handleListPPDBOffline,
      user,
      handleListStudentsPPDBF07,
      handleListStudentsPPDB,
      handleListStudentsClassDivGeneral,
      handleListStudentsPPDBRicci,
      handleListPPDBOfflineUPD,
    } = this.props;
    const { organizations_id, school_unit, user_group } = user;
    const { levels_id } = school_unit;

    let year = "";
    if (entrance_year) {
      year = entrance_year.toString().substring(2);
    }
    // let ent = JSON.parse(window.localStorage.getItem('entranceYear')) || "";
    // let savedForm = JSON.parse(window.localStorage.getItem('strukturForm')) || "";
    // let savedFilters = JSON.parse(window.localStorage.getItem('strukturFilters')) || filters;
    // console.log(ent)

    console.log(this.state.param.units);
    console.log(units_id);

    let periods_value = {};
    if (user_group.name == "pusat") {
      const param = this.state.param.units;
      const periods = units_id
        ? param.find((i) => i.value == units_id.value)
          ? param.find((i) => i.value == units_id.value).periods
          : ""
        : "";
      console.log(periods);

      map(periods, (data, idx) => {
        const date = new Date();
        const start_date = new Date(data.attributes.start_date);
        if (date > start_date) {
          // tahun ajaran selanjutnya
          // if (periods[idx + 1]) {
            periods_value = data.id;
          // }
        }
      });
    }

    const periods_year = periods_value
      ? periods_value.toString().substring(2)
      : "";
      console.log(periods_value)
    this.setState(async () => {
      try {
        const { handleGetDetailsPosition, user } = this.props;
        const { school_unit, organizations_id } = user;
        const result = await handleGetDetailsPosition({
          organizations_id,
          units_id: units_id.value,
          period_id: periods_value,
          filters,
        });

        this.setState((prevState) => ({
          ...prevState,
          form: {
            ...prevState.form,
            value: {
              ...prevState.form.value,
              details: result,
            },
          },
          // param: {
          //   ...prevState.param,
          //   positions: prm_fix,
          // }
        }));
      } catch (err) {
        // if (this.isMount) {
        this.setState((prevState) => ({
          ...prevState,
          form: {
            ...prevState.form,
            value: {
              ...prevState.form.value,
              details: [],
            },
          },
          // param: {
          //   ...prevState.param,
          //   positions: [],
          // }
        }));
      } finally {
        window.localStorage.setItem(
          "strukturForm",
          JSON.stringify(this.state.form)
        );
        window.localStorage.setItem(
          "strukturFilters",
          JSON.stringify(this.state.filters)
        );
      }
      // }
    });
  }

  async _getPeriodsOptions(filters = {}) {
    const { getPeriodsOptions, user } = this.props;
    const { organizations_id, school_unit, user_group } = user;
    const { form } = this.state;
    const { units_id } = form.value;
    const res = await getPeriodsOptions(filters);

    map(res, (data, idx) => {
      const date = new Date();
      const start_date = new Date(data.attributes.start_date);
      if (date > start_date) {
        // tahun ajaran sekarang
        this.setState((prevState) => ({
          ...prevState,
          filters: {
            ...prevState.filters,
            period: data.label,
            period_id: data.value,
          },
          form: {
            ...prevState.form,
            value: {
              ...prevState.form.value,
              period_id: data.value,
            },
          },
        }));
      }
    });

    this.setState((prevState) => ({
      ...prevState,
      param: {
        ...prevState.param,
        periods: res,
      },
    }));
  }

  _onFormChange(event) {
    const { form, param } = this.state;
    const { details } = form.value;
    const { user } = this.props;
    const { school_unit, organizations_id } = user;
    const { name, value, dataset, checked, type } = event.target;
    const {
      inputType = "text",
      inputArray = false,
      arrayPosition = 0,
      fieldName,
    } = dataset;
    this.setState(
      (prevState) => {
        let newList = [];
        let newListError = [];
        let formattedValue = value;

        if (inputType === "number") {
          formattedValue = normalizeAmount(value);
        }
        // if (name === "staff") {
        //   console.log(param)
        // }
        if (inputArray) {
          if (type === "checkbox") {
            formattedValue = checked;
          }
          newList = prevState.form.value[fieldName] || [];
          newListError = prevState.form.error[fieldName] || [];
         
          newList[arrayPosition][name] = formattedValue;
          if (name === "code_of_account") {
            newList[arrayPosition].isCredit = value.type;
          }
          if (!isEmpty(newListError[arrayPosition])) {
            newListError[arrayPosition][name] = "";
          }
        }
        return {
          form: {
            value: {
              ...prevState.form.value,
              ...(inputArray
                ? { [fieldName]: newList }
                : { [name]: formattedValue }),
            },
            error: {
              ...prevState.form.error,
              ...(inputArray ? { [fieldName]: newListError } : { [name]: "" }),
            },
          },
        };
      },
      () => {
        
        if (name === "classes_id") {
          this._getParamOptionsAcademics("classrooms", {
            classes_id: value,
            organizations_id,
          });
        }
      }
    );
  }

  handleGetData(payload = {}) {
    const { handleListPPDBOffline, user } = this.props;
    const { units_id, workingUnit, id, user_group, profile, organizations_id } =
      user;
    let unit_id = units_id;

    if (unit_id === null && workingUnit && workingUnit.id) {
      unit_id = workingUnit.id;
    }
    // const res = await handleListPPDBOffline({
    //   ...payload,
    //   user_id: id,
    //   organizations_id: organizations_id,
    // });

    this.setState({
      // list: res,
    });
  }

  async _getParamOptionsAcademics(type, filters = {}) {
    const { getParamOptionsAcademics, user } = this.props;
    const { organizations_id } = user;
    if (type === "classrooms" || type === "classrooms") {
      filters.organizations_id = organizations_id;
    } else {
      delete filters.organizations_id;
    }
    const res = await getParamOptionsAcademics(filters, type);
    this.setState((prevState) => ({
      ...prevState,
      param: {
        ...prevState.param,
        [type]: res,
      },
    }));
  }

  async _getPrmPositionOption() {
    const { getPrmPositionOption, user, handleGetDetailsPosition } = this.props;
    const { form, param, filters } = this.state;
    const { details } = form.value;
    const { school_unit, organizations_id } = user;
    const res = await getPrmPositionOption({
      unit_code: school_unit.unit_code,
    });

    const nip_default = details
      .filter((i) => i.is_default == 1)
      .map((i) => i.nip);
    const prm_fix = res
      ? res.filter((i) => !nip_default.includes(i.value))
      : "";

    this.setState((prevState) => ({
      ...prevState,
      param: {
        ...prevState.param,
        positions: prm_fix,
      },
    }));
  }

  async _getPrmPositionAdmOption() {
    const { getPrmPositionAdmOption, user, handleGetDetailsPosition } =
      this.props;
    const { form, param, filters } = this.state;
    const { details } = form.value;
    const { school_unit, organizations_id } = user;
    const res = await getPrmPositionAdmOption({
      unit_code: school_unit.unit_code,
    });

    this.setState((prevState) => ({
      ...prevState,
      param: {
        ...prevState.param,
        positions_adm: res,
      },
    }));
  }

  onClickAdd() {
    const { history } = this.props;
    history.push("/dashboard/kesiswaan/pendaftaran-ppdb");
  }

  onClickEdit(val) {
    const { history } = this.props;
    history.push("/dashboard/kesiswaan/pendaftaran-ppdb", {
      data: val,
      isEdit: true,
    });
  }

  onClickRutin(val) {
    const { history } = this.props;
    const { form } = this.state;
    val.units_id = form.value.units_id.value;

    if (val.no_va == "" || val.no_va == null) {
      errorAlert({
        title: "No VA belum tersedia.",
        errorMessage: "Mohon masukkan nomor pendaftaran di Data Siswa",
      });
    } else {
      history.push("/dashboard/tagihan-siswa/create-invoice/rutin/ppdb", {
        data: val,
        units: form.value.units_id,
      });
    }
  }

  onClickTidakRutin(val) {
    const { history } = this.props;
    const { form } = this.state;
    val.units_id = form.value.units_id.value;

    if (val.no_va == "" || val.no_va == null) {
      errorAlert({
        title: "No VA belum tersedia.",
        errorMessage: "Mohon masukkan nomor pendaftaran di Data Siswa",
      });
    } else {
      history.push("/dashboard/tagihan-siswa/create-invoice/tidak-rutin", {
        data: val,
      });
    }
  }

  onClickTidakRutinRICCI(val) {
    const { history } = this.props;
    const { form } = this.state;
    val.units_id = form.value.units_id.value;
    if (val.no_va == "" || val.no_va == null) {
      errorAlert({
        title: "No VA belum tersedia.",
        errorMessage: "Mohon masukkan nomor pendaftaran di Data Siswa",
      });
    } else {
      history.push(
        "/dashboard/tagihan-siswa/create-invoice/tidak-rutin-general",
        {
          data: val,
        }
      );
    }
  }

  onChangePage(page) {
    const { listAmount, keywords } = this.state;
    const offset = listAmount * (page - 1);
    this._onSearchContent({
      limit: listAmount,
      keywords,
      offset,
      page,
    });
  }

  async onSubmit() {
    const { history, handleUpdateDetailsPosition } = this.props;
    const { form } = this.state;
    const { value } = form;
    await handleUpdateDetailsPosition(value);
    history.push("/dashboard/pengaturan/struktur-unit");
    history.go(0);
  }

  async onPosting() {
    const { history, handlePostingPosition } = this.props;
    const { form } = this.state;
    const { value } = form;
    await handlePostingPosition(value);
    history.push("/dashboard/pengaturan/struktur-unit");
    history.go(0);
  }


    _renderButtons(data) {
      const { user } = this.props;
  
      return (
        <td>
          {data.is_delete == 0?
          <div className="table__actions">
            <Button onClick={() => this.onClickDelete(data)} title="Delete" />
          </div>
          :''}
        </td>
      );
    }

    async onClickSubmit() {
      const { history, handleAddDetailsPosition, user } = this.props;
      const { form } = this.state;
      const { value } = form;
      const { organizations_id } = user;
      await handleAddDetailsPosition(value);
      history.push('/dashboard/pengaturan/struktur-unit-pusat');
      history.go(0);
    }

  render() {
    const { form, filters, param } = this.state;
    const { details } = form.value;
    const prm_usergroups = param.userGroups;
    const prm_perwakilan = param.perwakilan_prm ? param.perwakilan_prm : "";
    const prm_units = param.units ? param.units : "";
    const All = [{ value: "all", label: "Semua Perwakilan", attributes: {} }];
    const AllUnit = [{ value: "all", label: "Semua Unit", attributes: {} }];
    const perwakilan_all = [...All, ...prm_perwakilan];
    const units_all = [...AllUnit, ...prm_units];
    const prm_positions = param.positions ? param.positions : "";
    const prm_block = [
      { value: 0, label: "Semua Tidak Aktif" },
      { value: 1, label: "Semua Aktif" },
    ];

    const prm_is_block = [
      { value: 0, label: "Tidak Aktif" },
      { value: 1, label: "Aktif" },
    ];

    const userStudents = prm_usergroups
      ? prm_usergroups.find((e) => e.label == "student")
      : "";

    //untuk memfilter data prm position yg hanya is_defaultnya 1 dan mengambil nip nya aja
    //  const nip_default = details.filter(i => i.is_default == 1).map(i => i.nip);
    //  const prm_fix = prm_positions?prm_positions.filter(i => !nip_default.includes(i.value)):'';

    return (
      <div className="manage-registration">
        <h1>Jabatan Tambahan</h1>
        <hr />
        <div className="absensi-rekap__custom-form">
          <br />

          <SearchSelect
            noMargin
            async={false}
            name="units_id"
            list={param.units}
            inputArray
            onClick={this._onChangeFilter}
            placeholder="Pilih Unit"
            value={form.value.units_id}
            rightIcon="icon-search"
            label="Pilih Unit"
          />
          <Select
            name="period_id"
            label="Tahun Ajaran"
            placeholder="Pilihan"
            onChange={this._onFormChange}
            data={param.periods}
            disabled={form.value.units_id?false:true}
            value={form.value.period_id}
          />
          <SearchSelect
            noMargin
            async={false}
            name="staff"
            list={param.staff}
            inputArray
            onClick={this._onFormChange}
            placeholder="Pilih Jabatan"
            value={form.value.staff}
            rightIcon="icon-search"
            label="Nama Jabatan"
          />
        </div>
        <br></br>
        <div className="student-list__header">
          <div className="student-list__button">
            <Button type="button" title="Simpan" onClick={this.onClickSubmit} />
          </div>
        </div>
        <div className="manage-registration">
          <div className="fund-request__content">
            <table className="table-structur">
              <thead>
                <tr>
                  <th>Jabatan</th>
                  <th>Opsi</th>
                </tr>
              </thead>
              {/* <h1 style={{marginLeft:"100%"}}>Jabatan</h1> */}
              <tbody>
                {map(details, (list, idx) => (
                  <tr key={`budget_row_${idx}`}>
                    <td
                      key={`table_${idx}`}
                      style={{ textAlign: "left", fontWeight: "bold" }}
                    >
                      {list.position}
                    </td>
                    {this._renderButtons(list)}
                  </tr>
                ))}
              </tbody>
            </table>
            
          </div>
        </div>
      </div>
    );
  }
}
StrukturUnitPusat.propTypes = {
  handleDelete: PropTypes.func,
  history: PropTypes.object.isRequired,
  user: PropTypes.object,
};
StrukturUnitPusat.defaultProps = {
  handleDelete: noop,
  user: null,
};
